<template>
  <header class="navbar">
    <!-- 左侧区域 -->
    <div class="navbar-left">
      <!-- Logo -->
      <img :src="companyLogUrl" @click="goToHome" class="logo" alt="Annanda Logo" width="185" height="30"
           fetchpriority="high"/>

      <!-- 网站名称 -->
      <span class="site-name" @click="goToHome">{{
          $t('anandaOnlineServicePlatform.anandaOnlineServicePlatform')
        }}</span>
    </div>

    <!-- 右侧区域 -->
    <div class="navbar-right">
      <!-- 快捷诊断-->
      <el-dropdown popper-class="custom-dropdown-popper" :disabled="isTesting">
        <span class="el-dropdown-link custom-dropdown-link"
              style="border: none !important; box-shadow: none !important;">
          <span style="font-size: 22px; margin: 0 10px; color: black;">
<svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" viewBox="64 64 896 896"
     focusable="false" data-icon="global" fill="currentColor" aria-hidden="true" width="1em" height="1em"><path
    d="M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z"></path></svg>
          </span>
         <span :style="{ color: 'black' }" class="navbar-title">{{ $t('settingPage.language') }}</span>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="(language, friendlyName) in supportedLanguages" :key="friendlyName"
                              @click="changeLanguage(friendlyName)"
                              @mouseenter="hover = friendlyName"
                              @mouseleave="hover = null"
                              :style="hover === friendlyName ? 'color: rgb(80,80,80); background-color: rgb(245,245,245);' : 'color: rgb(80,80,80); font-size:14px;background-color: transparent;'"

            >{{ friendlyName }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <!--  登录头像    -->
      <el-popover :width="popoverWidth"
                  placement="bottom-start"
                  popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 15px 0 10px 10px;">
        <template #reference>
          <div class="user-avatar" @click="showDialog">
            <span role="img" class="anticon index_icon text-color" style="font-size: 24px;">
              <svg style="font-size: 24px;" xmlns:xlink="http://www.w3.org/1999/xlink"
                   xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" focusable="false" class=""
                   width="1em" height="1em"><defs><symbol id="icon-xingzhuangjiehe" viewBox="0 0 1024 1024"><path
                  d="M512 42.666667a469.333333 469.333333 0 1 1 0 938.666666A469.333333 469.333333 0 0 1 512 42.666667z m0 554.666666a383.374222 383.374222 0 0 0-303.957333 149.333334A383.374222 383.374222 0 0 0 512 896a383.374222 383.374222 0 0 0 303.957333-149.333333A383.374222 383.374222 0 0 0 512 597.333333z m0-362.666666a149.333333 149.333333 0 1 0 0 298.666666 149.333333 149.333333 0 0 0 0-298.666666z"></path></symbol></defs><use
                  xlink:href="#icon-xingzhuangjiehe" fill-opacity="0.85" fill="#000000"></use></svg>

            </span>
          </div>
        </template>
        <template #default>
          <div class="demo-rich-content">
            <div>
              <p>{{ userEmail }}</p>
              <el-button link @click="settings()" class="setting-button">
                <p class="green-text">{{ $t('quickDiagnosis.settingsButton') }}</p>
              </el-button>
            <!-- 使用 <el-tag> 元素来表示 "超级管理员" 角色 -->
              <hr class="separator"> <!-- 使用 <hr> 元素来创建分隔线 -->
              <p>
                <a @mouseover="hoverLogoutIcon" @mouseleave="unhoverLogoutIcon" @click="logout" class="logout" href="#">
                  <svg class="logout-icon"
                       style="vertical-align: middle; width: 16px; height: auto; margin: 0 -5px 0 0;"
                       xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"
                       fill="none">
                    <path
                        d="M7.83334 1.99992C7.83334 2.36811 7.53487 2.66659 7.16668 2.66659H4.66668C3.95261 2.66659 3.36965 3.22791 3.33498 3.93337L3.33334 3.99992L3.33334 11.6666C3.33334 12.3807 3.89467 12.9636 4.60013 12.9983L4.66668 12.9999H7.16668C7.53487 12.9999 7.83334 13.2984 7.83334 13.6666C7.83334 14.0348 7.53487 14.3333 7.16668 14.3333H4.66668C3.22171 14.3333 2.04516 13.184 2.00128 11.7496L2.00001 11.6666L2.00001 3.99992C2.00001 2.55495 3.14929 1.3784 4.58362 1.33452L4.66668 1.33325L7.16668 1.33325C7.53487 1.33325 7.83334 1.63173 7.83334 1.99992Z"
                        fill="currentColor"></path>
                    <path
                        d="M10.5 4.77614C10.2397 4.51578 10.2397 4.09368 10.5001 3.83333C10.7604 3.57298 11.1825 3.57298 11.4429 3.83333L14.1953 6.58578C14.9764 7.36682 14.9764 8.63316 14.1953 9.4142L11.4429 12.1667C11.1825 12.427 10.7604 12.427 10.5001 12.1667C10.2397 11.9063 10.2397 11.4842 10.5 11.2238L13.7237 7.99999L10.5 4.77614Z"
                        fill="currentColor"></path>
                    <path
                        d="M6.66635 7.99996C6.66635 7.63177 6.96483 7.33329 7.33302 7.33329H13.9997C14.3679 7.33329 14.6664 7.63177 14.6664 7.99996C14.6664 8.36815 14.3679 8.66663 13.9997 8.66663H7.33302C6.96483 8.66663 6.66635 8.36815 6.66635 7.99996Z"
                        fill="currentColor"></path>
                  </svg>
                  &nbsp;&nbsp;{{ $t('quickDiagnosis.logoutText') }}
                </a>
              </p>

            </div>
          </div>
        </template>
      </el-popover>

    </div>
  </header>
</template>

<script>

import dialogMixin from "@/mixins/dialogMixin";
import {useRouter} from "vue-router";
import {defineComponent, onMounted, ref} from "vue";
import {
  logoutUser, showAccount,
  updateLang
} from "@/api/api";

import mitt from 'mitt';
import EventBus from "@/eventBus";

const emitter = mitt();

export default defineComponent({
  mixins: [dialogMixin],
  setup() {
    const router = useRouter(); // 使用 useRouter 获取路由实例
    const userEmail = ref('');
    const userRole = ref('');

    onMounted(() => {
      const user_email = localStorage.getItem('user_email') || '';
      const user_role = JSON.parse(localStorage.getItem('user_role')) || '';

      if (user_email) {
        userEmail.value = user_email;
      }
      if (user_role) {
        userRole.value = user_role[0];
      }
    });
    // 编辑按钮的点击事件处理函数
    const settings = () => {
      const settingsPagePath = `/SettingsPage`;
      // 使用路由导航到编辑页面
      router.push(settingsPagePath);
    };
    return {
      settings, // 返回编辑函数
      userEmail,
      userRole,
    };
  },
  data() {
    return {
      // 用于切换语言的标志位
      isChinese: true,
      // 用户头像的 URL，你可以根据实际情况设置
      userAvatarUrl: require("@/assets/image/user-avatar.webp"),
      companyLogUrl: require('@/assets/image/company-log.webp'),
      frequentQuestionUrl: require('@/assets/image/frequent-question.webp'),
      globalUrl: require('@/assets/image/global.webp'),
      personUrl: require('@/assets/image/person.webp'),
      logoutUrl: require('@/assets/image/logout.webp'),
      simplifyChineseUrl: require('@/assets/image/simplify-chinese.webp'),

      logoutUrlGreen: require('@/assets/image/logout-green.webp'), // 绿色图标路径
      currentLogoutIcon: require('@/assets/image/logout.webp'), // 当前显示的图标
      hover: null,

      supportedLanguages: {
        '简体中文': 'zh',
        'English': 'en',
        'Italiano': 'it',
        'Francais': 'fr',
        'Deutsch': 'de',
        'Dutch': 'nl',
        '日本語': 'ja',
        'Svenska': 'sv',
        'Magyar': 'hu',
        'Polski': 'pl',
        'Español': 'es',      // 添加西班牙语
        'Português': 'pt'     // 添加葡萄牙语
      },
      selectedLanguage: '',
      dialogVisible: false,
      isTesting: false,
    };
  },
  async created() {
    const userId = localStorage.getItem('userId');
    if (userId) {
      try {
        const accountDetails = await showAccount(userId);
        const lang = accountDetails.data.lang;
        const languageMappings = this.getLanguageMappings(); // 这里调用方法获取映射对象
        this.selectedLanguage = languageMappings[lang];
        await this.changeLanguage(this.selectedLanguage);
      } catch (error) {
        console.error('Failed to fetch account details:', error);
      }
    }
  },
  async mounted() {
    emitter.on('changeLanguage', this.changeLanguage.bind(this));
    EventBus.on('test-status-change', this.handleTestCompleted);
    EventBus.on('test-started', this.handleTestStarted);
    EventBus.on('analysis-started', this.handleAnalysisStarted);
    EventBus.on('isTesting', this.changeIsTestingVal);
  },
  beforeUnmount() {
    emitter.off('changeLanguage', this.changeLanguage);
    EventBus.off('test-status-change', this.handleTestCompleted);
    EventBus.off('test-started', this.handleTestStarted);
    EventBus.off('analysis-started', this.handleAnalysisStarted);
    EventBus.off('isTesting', this.changeIsTestingVal);
  },
  computed: {
    popoverWidth() {
      // 基础宽度
      let baseWidth = 240;
      // 根据 userEmail 长度增加宽度
      const additionalWidth = this.userEmail.length > 20 ? (this.userEmail.length - 20) * 7 : 0;
      return baseWidth + additionalWidth;
    }
  },
  methods: {
    changeIsTestingVal(isTesting) {
      this.isTesting = isTesting;
    },
    handleTestStarted(isTesting) {
      this.isTesting = isTesting;
    },
    handleAnalysisStarted(isAnalysising) {
      this.isTesting = isAnalysising;
    },
    handleTestCompleted(isTesting) {
      this.isTesting = isTesting;
    },
    goToHome() {
      this.$router.push('/ProductUpgrade'); // 确保 '/ProductUpgrade' 是主界面的正确路由路径
    },
    hoverLogoutIcon() {
      this.currentLogoutIcon = this.logoutUrlGreen;
    },
    unhoverLogoutIcon() {
      this.currentLogoutIcon = this.logoutUrl;
    },
    async changeLanguage(friendlyName) {
      this.selectedLanguage = friendlyName;
      const language = this.supportedLanguages[friendlyName];
      this.$store.dispatch('changeLanguage', {language, friendlyName});

      const updateData = {
        lang: language,
      };
      await updateLang(updateData);
      localStorage.setItem('lang', this.selectedLanguage);
    },
    showDialog() {
      // 这里无需编写任何代码，el-popover会处理显示和隐藏
      this.dialogVisible = true;
    },

    async logout() {
      try {
        // 调用 API 函数执行退出登录
        await logoutUser();
        // 退出登录成功后的操作
        // 清除本地存储或cookie中的认证数据
        localStorage.removeItem('token'); // 或 this.$cookies.remove('token');
        localStorage.removeItem('openeds');
        localStorage.removeItem('userId');
        localStorage.removeItem('userName');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_role');
        localStorage.removeItem('organizationId');
        localStorage.removeItem('organizationName');
        localStorage.removeItem('userCompany');
        localStorage.removeItem('userPhoneNumber');
        localStorage.removeItem('userCompanyLocation');
        localStorage.removeItem('userPostCode');
        const userId = localStorage.getItem('userId');
        const cacheKey = `userPermissions_${userId}`;
        const subCacheKey = `subPermissions_${userId}`;
        localStorage.removeItem(cacheKey);
        localStorage.removeItem(subCacheKey);
        // 重定向到登录页面
        this.$router.push('/LoginPage');
      } catch (error) {
        // 处理退出登录过程中可能出现的错误
        if (error.message === 'Session expired, please login again.') {
          // 如果会话过期，则清除本地存储中的数据并重定向到登录页面
          localStorage.removeItem('token');
          localStorage.removeItem('openeds');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('user_email');
          localStorage.removeItem('user_role');
          localStorage.removeItem('organizationId');
          localStorage.removeItem('organizationName');
          localStorage.removeItem('userCompany');
          localStorage.removeItem('userPhoneNumber');
          localStorage.removeItem('userCompanyLocation');
          localStorage.removeItem('userPostCode');
          const userId = localStorage.getItem('userId');
          const cacheKey = `userPermissions_${userId}`;
          const subCacheKey = `subPermissions_${userId}`;
          localStorage.removeItem(cacheKey);
          localStorage.removeItem(subCacheKey);
          this.$router.push('/LoginPage');
        } else {
          // 处理其他类型的错误
          console.error(this.$t('quickDiagnosis.logoutErrorMessage'), error);
        }
      }
    }
  },
});
</script>

<style scoped>
/* SVG 图标悬停状态 */
.logout-icon {
  transition: fill 0.3s; /* 平滑过渡 */
}

.logout:hover .logout-icon {
  fill: rgb(0, 154, 68); /* 绿色填充 */
}

.logout {
  color: black; /* 设置文本颜色为黑色 */
  text-decoration: none; /* 去除下划线 */
}

/* 为鼠标悬停在链接上时的样式添加规则，如果您也想更改这个 */
.logout:hover {
  color: rgb(0, 154, 68); /* 鼠标悬停时仍然保持黑色 */
  text-decoration: none; /* 鼠标悬停时仍然无下划线 */
}

.green-text {
  color: rgb(0, 154, 68);
  margin-top: 5px;
}

.custom-dropdown-link {
  border: none !important;
}

.el-dropdown-link {
  color: black;
}

/* 样式可以根据你的需要自定义 */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px; /* 设置顶部栏的高度为48px */
}

.navbar-title {
  white-space: nowrap; /* 防止文本换行 */
}

body {
  padding-top: 0; /* 确保body元素顶部没有内边距 */
}

.navbar-left {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px; /* 增加左边距 */
  cursor: pointer;
}

.logo {
  height: 30px;
  margin-right: 16px; /* 设置右边距为16px */
}

.site-name {
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap; /* 防止文本换行 */
}

.navbar-right {
  display: flex;
  align-items: center;
}

.navbar-link {
  margin-right: 20px;
  text-decoration: none;
  color: white;
}

.user-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}

.frequent-question {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 3px;
  font-size: 14px;
}

/*顶部栏的头像样式*/
.user-avatar {
  margin-left: 24px;
  margin-right: 24px;
}

.index_icon {
  cursor: pointer;
  color: #555;
  float: left;
}

.text-color {
  color: rgba(0, 0, 0, .85) !important;
}

.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.demo-rich-content {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: -10px;
  margin-bottom: -10px;
}

.setting-button {
  position: absolute;
  top: 10px;
  right: 10px;
}

/*退出登录样式*/
.logout {
  cursor: pointer;
}

a.logout:hover {
  color: #4CAF50
}

/* 添加样式规则来调整分隔线样式 */
.separator {
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  /* 调整分隔线上下的间距 */
  width: 100%;
  /* 横线占满整个宽度 */
  margin-left: 0;
  margin-right: 0;
}

</style>
